import http from '../../axios';
import {Player} from "@/store/player/types";
import {ExchangeAmount, ExchangeTerms} from "@/store/exchange/types";
import PlayerStore from "@/store/player";

export default class ExchangeStore {

    public static convertCurrencies(exchangeDtoFrom: ExchangeAmount): Promise<Player> {
        return http.post('/api/exchange/convert', exchangeDtoFrom)
            .then(r => r.data)
            .then(playerObj => {
                let player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static getExchangeTerms(): Promise<any> {
        return http.get('/api/exchange/terms')
            .then(r => r.data)
            .then(exchangeObj => {
                return Object.assign(new ExchangeTerms(), exchangeObj);
            });
    }

}
